import { render, staticRenderFns } from "./TipoCalculo.vue?vue&type=template&id=4c919bec"
import script from "./TipoCalculo.vue?vue&type=script&lang=js"
export * from "./TipoCalculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports